import styles from "./Picture.module.css";
import { withVersion } from "../../lib/assetVersions.js";

/**
 * Responsive image from the optimize-images naming convention.
 * `src` is the base path, e.g. "/images/site/hero/henderson". `version` (lib/assetVersions)
 * makes browsers fetch files that were regenerated under the same names.
 */
export default function Picture({
  src,
  alt,
  ratio = "16 / 9",
  widths = [480, 960, 1600],
  fallbackWidth = 1600,
  sizes = "(min-width: 64rem) 50vw, 100vw",
  priority = false,
  className = "",
  imgClassName = "",
  version,
}) {
  const srcSet = widths.map((w) => `${withVersion(`${src}-${w}.webp`, version)} ${w}w`).join(", ");
  return (
    <picture className={`${styles.picture} ${className}`.trim()} style={{ aspectRatio: ratio }}>
      <source type="image/webp" srcSet={srcSet} sizes={sizes} />
      <img
        className={`${styles.img} ${imgClassName}`.trim()}
        src={withVersion(`${src}-${fallbackWidth}.jpg`, version)}
        alt={alt}
        loading={priority ? "eager" : "lazy"}
        fetchPriority={priority ? "high" : "auto"}
        decoding="async"
      />
    </picture>
  );
}

export const PORTRAIT = { ratio: "4 / 5", widths: [320, 640, 800], fallbackWidth: 800 };
export const CARD = { ratio: "16 / 9", widths: [480, 960], fallbackWidth: 960 };
